export default __webpack_public_path__ + "static/banner-horses-mouth-70f70e3b0834da8b09b14cde6885ea9b.jpeg";